import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-indication-definition',
  templateUrl: './indication-definition.component.html',
  styleUrls: ['./indication-definition.component.css']
})
export class IndicationDefinitionComponent implements OnInit {

  @Input() definition: string;

  constructor() { }

  ngOnInit() {
  }

}
